import React from "react";
import "../Styles/sol_bg.css";
import Solutions from "./Solutions"
import SolarBannerImg from "../../Asserts/Oursolution_revised.png";

const SolutionHero = () => {
  return (
    <div className="solution-wrapper">

      {/* HEADER SECTION ABOVE IMAGE */}
      <div className="solution-header">
        <h2><span className="highlight-orange">OUR SOLAR</span> SIZING SOLUTION</h2>
        <p>Smart. Accurate. User-friendly.</p>
      </div>

      {/* IMAGE + CONTENT SECTION */}
      <div className="solution-hero-container">
        <Solutions />
        <div className="solution-hero-content">
          <h2>
            <span className="highlight-orange">UshasVas</span> our open
            source application will help you with solar
            capacity sizing and feasibility.
          </h2>
        </div>
      </div>

    </div>
  );
};

export default SolutionHero;
